import api from './api';

export interface VideoContainer {
  id: number;
  title: string;
  parent: number | null;
  created_by: number;
  created_at: string;
  updated_at: string;
  order: number;
  children_count: number;
  videos_count: number;
}

class VideoContainerService {
  async getAll(params?: any): Promise<VideoContainer[]> {
    const response = await api.get('/video-containers/', { params });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getContainers(parentId: number | null = null): Promise<VideoContainer[]> {
    const params = parentId === null ? { parent: 'null' } : { parent: parentId };
    const response = await api.get('/video-containers/', { params });
    // Handle paginated response
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getContainer(id: number): Promise<VideoContainer> {
    const response = await api.get(`/video-containers/${id}/`);
    return response.data;
  }

  async create(data: Partial<VideoContainer>): Promise<VideoContainer> {
    const response = await api.post('/video-containers/', data);
    return response.data;
  }

  async update(id: number, data: Partial<VideoContainer>): Promise<VideoContainer> {
    const response = await api.patch(`/video-containers/${id}/`, data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/video-containers/${id}/`);
  }

  async getContents(id: number): Promise<{ containers: VideoContainer[]; videos: any[] }> {
    const response = await api.get(`/video-containers/${id}/contents/`);
    return response.data;
  }

  async reorder(items: { id: number; order: number }[]): Promise<void> {
    await api.post('/video-containers/reorder/', { items });
  }
}

const videoContainerService = new VideoContainerService();
export default videoContainerService;
